import { EntityModel } from '@/interfaces'
import {
  ALL_PERSONAL_DISCOUNTS_QUERY,
  CREATE_PERSONAL_DISCOUNT_MUTATION,
  DELETE_PERSONAL_DISCOUNT_MUTATION,
  FORCE_DELETE_PERSONAL_DISCOUNT_MUTATION,
  SINGLE_PERSONAL_DISCOUNT_QUERY,
  UPDATE_PERSONAL_DISCOUNT_MUTATION,
} from './graphql'
import travelPricingMandatorySettingsEntity from '@/entities/travelPricingMandatorySettings/entity'

const ratioPersonalDiscountModel: EntityModel = {
  name: 'personalDiscount',
  namePlural: 'personalDiscounts',
  uniqueName: 'ratioPersonalDiscount',
  uniqueNamePlural: 'ratioPersonalDiscounts',
  path: 'travel/pricing/adaptors/ratio/personal_discount',
  baseUrl: '/travel/pricing/adaptors/ratio/personal_discounts',
  translationPrefix: 'entities:ratioPersonalDiscount.',
  getDisplayName: (values: any) => {
    return values.label
  },
  gql: {
    getAll: ALL_PERSONAL_DISCOUNTS_QUERY,
    getSingle: SINGLE_PERSONAL_DISCOUNT_QUERY,
    create: CREATE_PERSONAL_DISCOUNT_MUTATION,
    update: UPDATE_PERSONAL_DISCOUNT_MUTATION,
    delete: DELETE_PERSONAL_DISCOUNT_MUTATION,
    forceDelete: FORCE_DELETE_PERSONAL_DISCOUNT_MUTATION,
  },
  attributes: {
    ratioServiceNo: {
      name: 'ratioServiceNo',
      label: 'entities:ratioPersonalDiscount.attributes.ratioServiceNo.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'hidden',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    name: {
      name: 'name',
      label: 'entities:ratioPersonalDiscount.attributes.name.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'hidden',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    label: {
      name: 'label',
      label: 'entities:ratioPersonalDiscount.attributes.label.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    info: {
      name: 'info',
      label: 'entities:ratioPersonalDiscount.attributes.info.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'textarea',
      maxLength: 255,
      validationType: 'string',
      validations: [],
    },
    mandatorySettings: {
      name: 'mandatorySettings',
      label: 'entities:ratioPersonalDiscount.attributes.mandatorySettings.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return travelPricingMandatorySettingsEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
  },
}

export default ratioPersonalDiscountModel
